import V1 from './v1/LibreModuleV1'
import { IModule } from '@/contracts/core/module/interface/IModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'

export class LibreModuleProvider extends Provider<IModule> {
  realizations: Record<string, IModule> = {
    v1: V1(),
  }
}

const instance: { module: IModule | null } = { module: null }

export default function LibreModuleProviderModule(): IModule {
  const version = 'v1'

  if(!instance.module){
    instance.module = new LibreModuleProvider().module(version)
  }

  return instance.module
}
